/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ServicedeskKnowledgeHubBrowseAllArticlesType from '@jira/spa-apps__servicedesk-knowledge-hub-browse-all-articles/src/index.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskKnowledgeHubBrowseAllArticles: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof ServicedeskKnowledgeHubBrowseAllArticlesType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-servicedesk-knowledge-hub-browse-all-articles", jiraSpaEntry: "async-servicedesk-knowledge-hub-browse-all-articles" */ '@jira/spa-apps__servicedesk-knowledge-hub-browse-all-articles/src/index.tsx'
			),
		),
	);

const AsyncServicedeskKnowledgeHubBrowseAllArticles = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskKnowledgeHubBrowseAllArticles}
		pageId="spa-apps/servicedesk/knowledge-hub/browse-all-articles"
		shouldShowSpinner
	/>
);

export default AsyncServicedeskKnowledgeHubBrowseAllArticles;
